export default {
  cdn: 'https://wa.cdn-surfline.com/kbyg/',
  surflineHost: 'https://www.surfline.com',
  productAPI: 'https://services.surfline.com',
  servicesURL: 'https://services.surfline.com',
  legacyUrl: 'http://www.surfline.com',
  legacyApi: 'https://api.surfline.com/v1',
  camRewindUrl: spotId =>
    `https://www.surfline.com/surfdata/video-rewind/video_rewind.cfm?id=${spotId}`,
  camRewindUrlNonPremium: 'https://www.surfline.com/premium-benefits#cam-rewind',
  appKeys: {
    segment: 'Se6IGuzcvUhLx55hLHL0RiXkS6oUTz8L',
    amazonUAM: '15e39e15-7749-4909-bf7b-f5adb0a415e7',
    newrelic: '',
    splitio: process.env.SPLITIO_AUTHORIZATION_KEY || 'in20v2ebf6q1gh97ldcn1bp8ufdbr404e514',
    fbAppId: process.env.FB_APP_ID || '218714858155230',
  },
};
